
import React from 'react';
import { 
  Dialog, 
  DialogContent, 
  DialogHeader, 
  DialogTitle 
} from '@/components/ui/dialog';
import ArticlePreview from '@/components/dashboard/editor/ArticlePreview';

interface PreviewDialogProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  title: string;
  content: string;
  lead?: string;
  headerImageUrl?: string;
}

const PreviewDialog: React.FC<PreviewDialogProps> = ({
  isOpen,
  setIsOpen,
  title,
  content,
  lead,
  headerImageUrl
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="max-w-4xl max-h-[90vh] overflow-auto">
        <DialogHeader>
          <DialogTitle>Article Preview</DialogTitle>
        </DialogHeader>
        <ArticlePreview 
          title={title} 
          content={content} 
          lead={lead}
          headerImageUrl={headerImageUrl}
        />
      </DialogContent>
    </Dialog>
  );
};

export default PreviewDialog;
